var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('g', [_c('path', {
    attrs: {
      "d": "M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10Z",
      "opacity": ".4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15 11.75c-.72 0-1.25-.74-1.25-1.75s.53-1.75 1.25-1.75 1.25.74 1.25 1.75-.53 1.75-1.25 1.75ZM10.25 10c0-1.01-.53-1.75-1.25-1.75S7.75 8.99 7.75 10s.53 1.75 1.25 1.75 1.25-.74 1.25-1.75Zm5.5 6c0-.41-.34-.75-.75-.75H9c-.41 0-.75.34-.75.75s.34.75.75.75h6c.41 0 .75-.34.75-.75Z",
      "stroke": "#000000",
      "stroke-width": ".3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }